export default __webpack_public_path__ + "static/media/Bitbucket Icon.d956841a.svg";